(function () {
  if (window._crFpAtcInit) return;
  window._crFpAtcInit = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cr-fp-atc-btn');
    if (!btn || btn.dataset.busy) return;
    // Carousel track has its own handler with drag awareness
    if (btn.closest('.cr-fp-track')) return;
    var variantId = btn.dataset.variantId;
    if (!variantId) return;
    var originalText = btn.textContent.trim();
    var addedText = btn.dataset.addedText || 'Added!';
    btn.dataset.busy = '1';
    btn.classList.add('is-loading');
    btn.textContent = 'Adding...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.textContent = addedText;
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(function () {
          btn.textContent = originalText;
          btn.classList.remove('is-added');
          delete btn.dataset.busy;
        }, 2000);
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.textContent = originalText;
        delete btn.dataset.busy;
      });
  });
})();
